import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from '../Dropdown';
import { Label } from '../Label';
import { Text } from '../Text';
import { TextInput } from '../TextInput';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

const GET_SERVICES = gql`
  query Service($searchValue: String!) {
        services(name: $searchValue) {
            name
        }
    }
`;

export const SearchComboBox: React.FC = () => {

  const [searchValue, setSearchValue] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  let services = [];

  const { error, data } = useQuery(GET_SERVICES, {
    variables: { searchValue },
  });

  if(error){
    console.log('error: ', error);
  }

  if(data){
    const reducedServices = data.services.reduce(function (total: any, obj: any) {
      total.push(obj['name']);
      return total;
    }, []);

    services = reducedServices;
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target;
    setSearchValue(value);
    setIsDropdownOpen(!!value.trim().length);
  }

  function handleFocus() {
    setIsDropdownOpen(!!searchValue.trim().length);
  }

  function handleBlur() {
    // set a small buffer to allow links to be clicked before closing the menu
    setTimeout(() => {
      setIsDropdownOpen(false);
    }, 150);
  }

  function renderListItems(items: string[]) {
    const filteredList = items.filter(item => item.startsWith(searchValue));

    if (!filteredList.length) {
      return (
        <Dropdown.ListItem>
          <Text className="italic pad-x-m pad-y-xs">no services found</Text>
        </Dropdown.ListItem>
      );
    }

    return filteredList.map((item, i) => (
      <Dropdown.ListItem key={i}>
        <Link className="dropdown-link" to={`/services/${item}`}>
          {item}
        </Link>
      </Dropdown.ListItem>
    ));
  }

  return (
    <Dropdown.Container isActive={isDropdownOpen}>
      <Label>Search</Label>
      <TextInput value={searchValue} onBlur={handleBlur} onChange={e => handleChange(e)} onFocus={handleFocus} />
      <Dropdown.Menu>{renderListItems(services)}</Dropdown.Menu>
    </Dropdown.Container>
  );
};
